import {
  Component,
  NgModule,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';


import { DxButtonModule } from 'devextreme-angular/ui/button';

import { ThemeSwitcherModule } from 'src/app/components/library/theme-switcher/theme-switcher.component';
import { UserPanelModule } from '../user-panel/user-panel.component';
import { AuthService, IUser } from 'src/app/services/auth/auth.service';
import { WikiShortcutModule } from '../wiki-shortcut/wiki-shortcut.component';
import { NotificationsPanelModule } from '../notifications-panel/notifications-panel.component';
import { PatriciaShortcutModule } from '../patricia-shortcut/patricia-shortcut.component';
import { PortalShortcutModule } from '../portal-shortcut/portal-shortcut.component';
import { TimeRegistrationShortcutComponent } from "../time-registration-shortcut/time-registration-shortcut.component";
import { AiAskBarComponent } from '../ai-ask-bar/ai-ask-bar.component';
import { ScheduleOfChargesShortcutComponent } from '../schedule-of-charges-shortcut/schedule-of-charges-shortcut.component';

@Component({
  selector: 'app-header',
  templateUrl: 'app-header.component.html',
  styleUrls: ['./app-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    DxButtonModule,
    ThemeSwitcherModule,
    UserPanelModule,
    WikiShortcutModule,
    NotificationsPanelModule,
    PatriciaShortcutModule,
    PortalShortcutModule,
    TimeRegistrationShortcutComponent,
    ScheduleOfChargesShortcutComponent,
    AiAskBarComponent
],
})
export class AppHeaderComponent implements OnInit {
  @Output()
  menuToggle = new EventEmitter<boolean>();

  @Input()
  menuToggleEnabled = false;

  @Input()
  title!: string;

  @Input()
  sectionTitle = '';

  @Input()
  sectionParent = '';

  @Input()
  imageSource: string;

  user: IUser | null = { email: '' };

  userMenuItems = [
    {
      text: 'Logout',
      icon: 'runner',
      onClick: () => {
        this.authService.logOut();
      },
    },
  ];

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.authService.getUser().then((e) => (this.user = e.data));
  }

  toggleMenu = () => {
    this.menuToggle.emit();
  };
}
